import React from 'react';
import { Link, navigate } from '@reach/router';
import { AvForm } from "availity-mobx-reactstrap-validation";
import AppContent from "js/components/AppContent";
import Button from 'js/components/common/Button';
import analytics from 'js/services/Analytics';
import StepStatus from "js/components/core/SteppedPage/StepStatus";
import PageComponent from 'js/components/pages/PageComponent';
import { lightGrey1Color } from 'js/config/style';
import CreateItemPageState from "js/stores/pages/CreateItemPageState";
import { observer } from 'mobx-react';
import Content from '../Content';
import Sidebar from '../Sidebar';
import ImageAndPrice from './Components/ImageAndPrice';
import ItemView from './Components/ItemView';
import PickupDetails from './Components/PickupDetails';
import SizeDetails from './Components/SizeDetails';
import { makeRequest, url, errorResponse } from 'js/services/Network';
import { forEach } from 'lodash';
import AppState from "js/stores/AppState";
import Modal from 'js/components/core/Modal';
import { AppButton } from 'js/new/Components/App';

@observer
export default class CreateItemPage extends PageComponent {

  pageName = 'UserDashboardPage';
  trackingName = 'SP_create_link';
  pageColor = lightGrey1Color;
  pageWidth = '1200px';

  constructor(props) {
    super(props);

    this.state = {
      catalog: [],
      errorMessage: null,
      showModal: false
    };

    this.page = CreateItemPageState.create();
  }

  bootstrap = () => this.page.load();

  pageEvent = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('cv')) {
      analytics.goal('landing_conversion');
    }
  };

  addToCatalog = () => {
    let item = {};
    item.address = this.page.address;
    item.title = this.page.title;
    item.price = this.page.price;
    item.size = this.page.size;
    item.quantity = this.page.quantity;
    item.anonymous_id = this.page.anonymous_id;
    item.images = [this.page.primary_image];
    item.description = 'new trending';

    let myArray = this.state.catalog;
    myArray.push(item);

    this.setState({ catalog: myArray });

    this.page = CreateItemPageState.create();

    return this.state.catalog;
  }

  submit = async () => {
    this.addToCatalog()

    let response;

    if (!this.page.isSubmitting) {
      this.page.setIsSubmitting(true);
      this.page.setError(null);

      try {
        response = await makeRequest(
          'create-new-payment-link',
          null,
          this.state.catalog,
        );

        const alias = response.data.alias;

        forEach(this.catalog, (item) => {
          analytics
            .track('Offer Link Created', {
              'Item Price': item.price,
              'Item Name': item.title,
              'Item Quantity': item.quantity || '1',
              'Item Size': item.size,
              'Payment Link': url('checkout-page', { alias }),
              'Location': AppState.currentPage,
              'Event Initiated by': 'seller'
            });
        })

        this.setState({ showModal: true })

      } catch (error) {
        this.page.setError(errorResponse(error));
      }

      this.page.setIsSubmitting(false);
    }

    return response;
  }

  closeModal = () => {
    this.setState({ showModal: false });

    navigate('/dashboard/items')
  }

  refresh = () => {
    window.location.reload();
  }

  getStepView = () => {
    const views = [
      <ImageAndPrice />,
      <SizeDetails />,
      <PickupDetails value={this.page.address} />,
      <div>
        <h6 className='tw-font-semibold'>Finish up</h6>
        <p className='tw-mb-4'>Push the “upload" button to upload the items to your checkout or add more item.</p>

        <div className="tw-mt-5 tw-space-y-3">
          <Button onClick={this.submit}>Upload item</Button>

          <Button inverted onClick={this.addToCatalog} >Add another item</Button>
        </div>
      </div>
    ]

    return views[this.page.currentStep - 1];
  }

  renderPage() {
    const page = this.page;

    return (
      <AppContent className='user-dashboard d-lg-flex align-items-stretch'>
        <Sidebar currentPage='ItemsListPage' pageState={page} />

        <Content currentPage='ItemsListPage' showCards={false} className='new-pod-ui'>
          <div className='bg-white tw-p-4 md:tw-px-8 mt-3 tw-rounded-xl tw-flex tw-justify-between tw-items-center mt-4'>
            <h3 className="tw-mb-0">My Offers</h3>
            <AppButton className='tw-flex tw-items-center tw-gap-4' href='/dashboard/items'>
              + Create Item
            </AppButton>
          </div>

          <div className="dashboard-page tw-grid md:tw-grid-cols-2">
            <div className='tw-border-solid tw-border-0 md:tw-border-r-2 tw-border-gray-100 tw-px-2 tw-py-4 md:tw-pr-6'>
              <AvForm onValidSubmit={page.nextDetail}>
                {this.getStepView()}
                <StepStatus />
              </AvForm>
            </div>

            <div className='tw-px-2 tw-py-4 md:tw-pl-6'>
              <h6 className='tw-font-semibold tw-mb-4'>Item preview</h6>
              {(!this.state.catalog.length && !page.title)
                ? <div className="text-center tw-p-6 tw-space-y-4">
                  <img
                    src="/images/v2/sellers/loading-img.png"
                    alt="Add Image"
                    style={{ height: '131px', }}
                    className='tw-max-w-full'
                  />
                  <h6 className="tw-font-semibold" >Item added will be shown here</h6>
                  <p className='small'>
                    The Items you add to your checkout will be listed here.
                  </p>
                </div>
                : <div>
                  {this.state.catalog?.map((item, index) => <ItemView key={index} item={item} />)}

                  <ItemView item={{
                    title: page.title,
                    price: page.price,
                    size: page.size,
                    quantity: page.quantity,
                    address: page.address,
                    images: [page.primary_image],
                  }} />
                </div>
              }
            </div>
          </div>
        </Content>

        <Modal
          showModal={this.state.showModal}
          onCancel={this.closeModal}
          withCloseButton>
          <div className='tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center gap-4 tw-px-4 md:tw-px-8 tw-pb-4'>
            <div className='tw-flex tw-justify-center tw-items-center'>
              <img
                src="/assets/images/success.png"
                alt="Congratulations"
                style={{ width: '60px', height: '60px' }}
              />
            </div>

            <h2>Success</h2>

            <p>Your item(s) has been uploaded to your checkout page</p>

            <Button onClick={this.refresh}>Add another item</Button>

            <Link to='/dashboard/items' >
              <p className="!tw-mb-0 tw-flex tw-items-center gap-4 tw-font-bold tw-text-primary">
                Back to Items
              </p>
            </Link>
          </div>
        </Modal>
      </AppContent>
    )
  }
}
